module.exports = __webpack_public_path__ + "img/5.c0427e97.jpg";